import { ConversationMessage } from '../../../core/src/lib/interface/conversation.interface';

export class MessageGroup {
  readonly id: string;
  readonly participantId: string;
  messages: ConversationMessage[] = [];
  created?: Date;

  constructor(messageId: string, participantId: string, created?: Date) {
    this.id = `message-group-${messageId}`;
    this.participantId = participantId;
    this.created = created;
  }

  addMessage(message: ConversationMessage): void {
    this.messages.push(message);
  }

  get lastMessage(): ConversationMessage {
    return this.messages[this.messages.length - 1];
  }
}
